'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ramda = require('ramda');

var _ramdaAdjunct = require('ramda-adjunct');

var _errors = require('../errors');

var getApiFromProps = function getApiFromProps(errorFunc) {
  return function (props) {
    return (0, _ramda.pipe)((0, _ramda.prop)('theme'), (0, _ramda.unless)(_ramdaAdjunct.isPlainObj, function (value) {
      return errorFunc((0, _errors.noThemeObjectError)(value));
    }), (0, _ramda.prop)('api'), (0, _ramda.unless)(_ramdaAdjunct.isFunction, function (value) {
      return errorFunc((0, _errors.noAPIOnThemeError)(value));
    }))(props);
  };
};

exports.default = getApiFromProps;


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/themeHelpers/getApiFromProps.js
// module id = 342
// module chunks = 168707334958949